
const LineModel = ({ radius=0.03, length=1, position=[0, 0, 0], rotation=[0, 0, 0], color='#2F7CBF'}) => {

    return (
        <group position={position} rotation={rotation}>
            <mesh>
                <cylinderGeometry attach="geometry" args={[radius, radius, length, 6]} />
                <meshBasicMaterial color={color}/>
            </mesh>
            {/* <mesh position={[0, length / 2 - 0.2, 0]}>
                <coneGeometry attach="geometry" args={[radius * 3, 0.4, 6]} />
                <meshBasicMaterial color={color} />
            </mesh>
            <mesh position={[0, -length / 2 + 0.2, 0]} rotation={[Math.PI, 0, 0]}>
                <coneGeometry attach="geometry" args={[radius * 3, 0.4, 6]} />
                <meshBasicMaterial color={color} />
            </mesh> */}
        </group>
    )
}

export default LineModel